module.exports = __webpack_public_path__ + "img/golden-hunter.597e25aa.jpg";